export const CheckmarkIcon = () => {
  return (
    <svg width="14" height="11" viewBox="0 0 14 11" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M1 5L5 9L13 1" stroke="#3C9A35" stroke-width="2" stroke-linecap="round" />
    </svg>
  );
};
